export const getImageUrl = (url: string | undefined): string => {
  if (!url) return '';
  
  // Quick fix: If URL already contains the full API URL, return it as is
  if (url.includes(import.meta.env.VITE_API_URL)) {
    return url;
  }
  
  // Handle the specific case where URL has /api/images//api/v1 pattern
  if (url.includes('/api/images//api/v1')) {
    // Extract just the filename
    const filename = url.split('/').pop() || '';
    return `${import.meta.env.VITE_API_URL}/api/images/${filename}`;
  }
  
  // If URL already starts with /api/images, just prepend the base URL
  if (url.startsWith('/api/images/')) {
    return `${import.meta.env.VITE_API_URL}${url}`;
  }
  
  // For any other case, ensure the URL goes to /api/images/
  const cleanUrl = url
    .replace(/^\/api\/v1\/+/g, '')    // Remove any /api/v1/ prefix
    .replace(/^\/+/g, '')             // Remove leading slashes
    .replace(/\/+/g, '/');            // Replace multiple slashes with single slash

  const finalUrl = `${import.meta.env.VITE_API_URL}/api/images/${cleanUrl}`;
  console.log('Cleaned URL:', finalUrl);
  return finalUrl;
}; 